import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Attachment, AttachmentsByQuestion } from "../../types/attachment";

export interface AttachmentState {
    attachmentsByQuestion: AttachmentsByQuestion;
    loading: boolean;
    error: boolean;
    currentInspectionId: string | null;
    viewingAttachments: Attachment[];
}

export const initialState: AttachmentState = {
    attachmentsByQuestion: {},
    loading: false,
    error: false,
    currentInspectionId: null,
    viewingAttachments: [],
};

export const attachmentSlice = createSlice({
    name: "attachment",
    initialState,
    reducers: {
        setAttachments: (state, action: PayloadAction<{ inspectionId: string; attachments: AttachmentsByQuestion }>) => {
            state.attachmentsByQuestion = action.payload.attachments;
            state.currentInspectionId = action.payload.inspectionId;
            state.error = false;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<boolean>) => {
            state.error = action.payload;
        },
        setViewingAttachments: (state, action: PayloadAction<Attachment[]>) => {
            state.viewingAttachments = action.payload;
        },
        clearAttachments: (state) => {
            state.attachmentsByQuestion = {};
            state.currentInspectionId = null;
            state.error = false;
            state.viewingAttachments = [];
        },
    },
});

export const { setAttachments, setLoading, setError, setViewingAttachments, clearAttachments } = attachmentSlice.actions;

export default attachmentSlice.reducer;
